module.exports = __webpack_public_path__ + "static/media/072.d79dd21d.jpg";